export function markCatalogMediaCover(items, coverIndex) {
  return items.map((item, itemIndex) => ({
    ...item,
    isCover: itemIndex === coverIndex,
  }));
}

export function mapCatalogMediaSaveItems(items, mapItem) {
  return items.map((item, index) => mapItem(item, index + 1));
}
